import { render, staticRenderFns } from "./edit-pharmacy.vue?vue&type=template&id=4f8d9179&scoped=true&"
import script from "./edit-pharmacy.vue?vue&type=script&lang=js&"
export * from "./edit-pharmacy.vue?vue&type=script&lang=js&"
import style0 from "./edit-pharmacy.vue?vue&type=style&index=0&id=4f8d9179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8d9179",
  null
  
)

export default component.exports